import React, {Component} from 'react';
import './index.css'

class BsyMonthYearPane extends Component {
    minYear = 1900
    maxYear = 2999
    monthArray = [
        React.language("date.january"),
        React.language("date.february"),
        React.language("date.march"),
        React.language("date.april"),
        React.language("date.may"),
        React.language("date.june"),
        React.language("date.july"),
        React.language("date.august"),
        React.language("date.september"),
        React.language("date.october"),
        React.language("date.november"),
        React.language("date.december")
    ]
    trNum = [0,1,2,3,4,5]
    weekArray = [
        React.language("date.monday.short"),
        React.language("date.tuesday.short"),
        React.language("date.wednesday.short"),
        React.language("date.thursday.short"),
        React.language("date.friday.short"),
        React.language("date.saturday.short"),
        React.language("date.sunday.short")
    ]
    constructor(props) {
        super(props);
        this.state = {
            year:props.year,
            month:props.month,
            day:props.day,
            mode:props.mode,
        }
    }
    yearPrev = () =>{
        const {year,mode} = this.state;
        let s = year - (year%10 + 1) + 1;
        if(s === this.minYear || year === this.minYear){
            return
        }
        const num = mode === "yearMode" ? 10 : 1
        this.setState({
            year:year - num
        },()=>{
            this.changeMonthYear()
        })
    }
    yearNext = () =>{
        const {year,mode} = this.state;
        let s = year - (year%10 + 1) + 10;
        if(s === this.maxYear || year === this.maxYear){
            return
        }
        const num = mode === "yearMode" ? 10 : 1
        this.setState({
            year:year + num
        },()=>{
            this.changeMonthYear()
        })
    }
    changeMonth = (m) =>{
        return () =>{
            this.setState({
                month:m
            },()=>{
                this.changeMonthYear()
                if(this.props.mode === "dayMode"){
                    this.setState({
                        mode:"dayMode"
                    })
                }
            })
        }
    }
    toMonth = () =>{
        const {month,year} = this.props;
        this.setState({
            month:month,
            year:year
        },()=>{
            this.changeMonthYear()
        })
    }
    changeMonthYear = () =>{
        const {year, month} = this.state;
        if(this.props.changeMonthYear){
            this.props.changeMonthYear(year, month)
        }
    }
    changeDay = (day, mon, year) =>{
        return () =>{
            this.setState({
                year : year,
                month : mon,
                day : day
            },()=>{
                if(this.props.changeDayMenu){
                    this.props.changeDayMenu(day, mon, year)
                }
            })
        }
    }
    renderDateMode = () =>{
        const {year, month, day, mode} = this.state;
        const date = new Date(year + "-" + (month + 1) + "-" + day);
        let y = 0;
        let s = year - (year%10 + 1) - 1;
        date.setDate(1);
        date.setDate(0 - (7 & date.getDay()));
        date.setDate(date.getDate() + 1);
        switch (mode) {
            case "dayMode":
                return <div className="calendarCont">
                    <table>
                        <thead>
                        <tr>
                            {
                                this.weekArray.map((res) => {
                                    return <th className="day week">
                                        {
                                            res
                                        }
                                    </th>
                                })
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.trNum.map((res) => {
                                return <tr>
                                    {
                                        this.weekArray.map((res, key) => {
                                            y = date.getDate()
                                            let day1 = date.getDate()
                                            let mon = date.getMonth()
                                            let year = date.getFullYear()
                                            date.setDate(y + 1)
                                            return <td onClick={this.changeDay(day1, mon, year)}
                                                       className={"day" + ((this.props.day === y && this.props.month === mon && this.props.year === year) ? " today" : "") + ((day === y && month === mon) ? " selected" : "") + (month !== mon ? " odd" : "")}>
                                                <div className="day-wrapper">
                                                    <div className="day-item">
                                                        {
                                                            y
                                                        }
                                                    </div>
                                                </div>
                                            </td>
                                        })
                                    }
                                </tr>
                            })
                        }
                        </tbody>
                    </table>
                </div>
            case "monthMode":
                return <div className="calendarMonth">
                    {
                        this.monthArray.map((res,key)=>{
                            return <div className="item-cell" onClick={this.changeMonth(key)}>
                                <div className={"cell-btn" + (key === month ? " selected" : "")}>
                                    {
                                        res
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
            case "yearMode":
                return <div className="calendarYear">
                    {
                        this.monthArray.map((res,key)=>{
                            s++
                            return <div className="item-cell">
                                <div onClick={this.changeYear(key,s)} className={"cell-btn" + (key === 0 ? " last-year" : key === 11 ? " next-year" : "") + (s < this.minYear ? " disabled" : "") + (year === s ? " selected" : "")}>
                                    {
                                        s
                                    }
                                </div>
                            </div>
                        })
                    }
                </div>
            default:
                return '';
            
        }
    }

    changeYear = (key,s) =>{
        return () =>{
            const {month, day} = this.state;
            if(s <= this.minYear || s >= this.maxYear){
                return
            }
            if(key !==0 && key !==11){
                this.setState({
                    year:s,
                    mode:"monthMode"
                },()=>{
                    if(this.props.changeDayMenu){
                        this.props.changeDayMenu(day, month, s)
                    }
                })
            }else{
                this.setState({
                    year:s
                },()=>{
                    if(this.props.changeDayMenu){
                        this.props.changeDayMenu(day, month, s)
                    }
                })
            }
        }
    }

    changeMonthMode = () =>{
        this.setState({
            mode:"monthMode"
        })
    }

    changeYearMode = () =>{
        this.setState({
            mode:"yearMode"
        })
    }

    isLeapMonth = (year) =>{
        if(year % 4 === 0 && year % 100 !== 0 || year % 400 === 0){
            return [31,29,31,30,31,30,31,31,30,31,30,31]
        }else{
            return [31,28,31,30,31,30,31,31,30,31,30,31]
        }
    }

    monthPrev = () =>{
        const {month,year,day} = this.state;
        if(month === 0){
            const numDay = this.isLeapMonth((year - 1))
            this.setState({
                year : year - 1,
                month : 11,
                day : numDay[11] > day ? day : numDay[11]
            },()=>{
                if(this.props.changeDayMenu){
                    this.props.changeDayMenu(numDay[11] > day ? day : numDay[11], 11, year - 1)
                }
            })
        }else{
            const numDay = this.isLeapMonth(year)
            this.setState({
                month : month - 1,
                day : numDay[month - 1] > day ? day : numDay[month - 1]
            },()=>{
                if(this.props.changeDayMenu){
                    this.props.changeDayMenu(numDay[month - 1] > day ? day : numDay[month - 1], month - 1, year)
                }
            })
        }

    }

    monthNext = () =>{
        const {month,year,day} = this.state;
        if(month === 11){
            const numDay = this.isLeapMonth((year + 1))
            this.setState({
                year : year + 1,
                month : 0,
                day : numDay[0] > day ? day : numDay[0]
            },()=>{
                if(this.props.changeDayMenu){
                    this.props.changeDayMenu(numDay[0] > day ? day : numDay[0], 0, year + 1)
                }
            })
        }else{
            const numDay = this.isLeapMonth(year)
            this.setState({
                month : month + 1,
                day : numDay[month + 1] > day ? day : numDay[month + 1]
            },()=>{
                if(this.props.changeDayMenu){
                    this.props.changeDayMenu(numDay[month + 1] > day ? day : numDay[month + 1], month + 1, year)
                }
            })
        }
    }

    render() {
        const {year, month, mode} = this.state
        return (
            <div className="bsy-monthYearPane">
                <div className="date-head">
                    <div className="head-btn btn-prev">
                        <i className="icon-double-left" onClick={this.yearPrev} />
                        {mode === "dayMode" && <i className="icon-bsy-iconzuofanhui" onClick={this.monthPrev}/>}
                    </div>
                    <div className="head-btn btn-year">
                        {mode === "dayMode" && <div className="btnGroup">
                            <span className="on" onClick={this.changeYearMode}>
                                {
                                    React.language("date.year", {year: year})
                                }
                            </span>
                            <span className="on" onClick={this.changeMonthMode}>
                                {
                                    React.language("date.month", {month: (month + 1)})
                                }
                            </span>
                        </div>}
                        {mode === "monthMode" && <div className="btnGroup">
                            <span className="on" onClick={this.changeYearMode}>
                                {
                                    React.language("date.year", {year: year})
                                }
                            </span>
                        </div>}
                        {mode === "yearMode" && <div className="btnGroup">
                            <span>
                                {
                                    React.language("date.year", {year: year - (year%10 + 1) + 1})
                                }
                            </span>
                            ~
                            <span>
                                {
                                    React.language("date.year", {year: year - (year%10 + 1) + 10})
                                }
                            </span>
                        </div>}
                    </div>
                    <div className="head-btn btn-next">
                        {mode === "dayMode" && <i className="icon-bsy-iconzuofanhui" onClick={this.monthNext}/>}
                        <i className="icon-double-left" onClick={this.yearNext} />
                    </div>
                </div>
                <div className="date-month" style={{height:mode === "dayMode" ? "230px" : "270px"}}>
                    {
                        this.renderDateMode()
                    }
                </div>
                {mode === "dayMode" && <div className="date-foot" onClick={this.toMonth}>
                    <div className="foot-btn">
                        {
                            React.language("date.thisMonth")
                        }
                    </div>
                </div>}
            </div>
        );
    }
}

export default BsyMonthYearPane;